import React from 'react'
import NavBarMain from './NavBarMain'
import RootPage from './RootPage'

const MainContent = () => {
  return (
    <div>
        {/* <NavBarMain /> */}
           <NavBarMain />
        <RootPage />
    </div>
  )
}

export default MainContent